import {IBooking, IPaymentDetails} from "app/app.types";
import {ITableDate} from "app/bookings/new/types/newBooking.types";

const NS = 'EditBookingOptions';

export default function EditBookingOptions(
  $scope: any, $mdDialog: any, booking: IBooking, paymentDetails: IPaymentDetails, maxCovers: number,
  serviceId: string, currency: string, bookingTimes: ITableDate[], bookingDate: Date, $timeout: any, isUpsell: any
) {
  "ngInject";

  const vm = this;
  vm.cancel = cancel;
  vm.checkForSave = checkForSave;
  vm.updateBookingOption = updateBookingOption;
  vm.handleMaxCovers = handleMaxCovers;

  /**
   * Because this controller gets added via $mdDialog, there is no default lifecycle hooks,
   * so this needs to get called from within the `onComplete` callback.
   */
  $scope.$onInit = function () {
    vm.booking = booking;
    vm.isUpsell = isUpsell;
    vm.paymentDetails = paymentDetails;
    vm.maxCovers = maxCovers;
    vm.serviceId = serviceId;
    vm.currency = currency;
    vm.bookingTimes = bookingTimes;
    vm.bookingDate = bookingDate;
    vm.bookingOptionsValid = true;
  }

  function cancel() {
    $mdDialog.hide();
  }

  function checkForSave() {
    $timeout(function () {
      $mdDialog.hide(vm.booking.selectedMenuOptions || booking.selectedMenuOptions);
    }, 300);
  }

  function updateBookingOption(updatedBooking: IBooking): void {
    if (vm.bookingOptionsValid) {
      vm.booking.selectedMenuOptions = updatedBooking.selectedMenuOptions.filter(item => {
        const itemIsUpsell = !!item.isUpsellItem; // can be undefined, so needs to be forced to boolean with !!
        return item.quantity > 0 && itemIsUpsell === vm.isUpsell;
      });
    }
  }

  function handleMaxCovers(isSuccess: boolean) {
    vm.bookingOptionsValid = isSuccess;
  }
}
